import React from 'react'
import { Tab, styled } from '@mui/material'

export const Root = styled(({ align, display, isSelected, padding, width, ...props }) => <Tab {...props} />)`
  &.MuiTab-root {
    border-left: ${({ isSelected, theme }) => (isSelected ? `2px solid ${theme.palette.blue[50]}` : '')};
    border-radius: 4px;
    border-bottom-left-radius: ${props => (props.isSelected ? '0' : '4px')};
    border-top-left-radius: ${props => (props.isSelected ? '0' : '4px')};
    color: ${({ isSelected, theme }) => (isSelected ? theme.palette.blue[50] : theme.palette.gray[50])};
    display: ${props => props.display};
    font-size: 14px;
    font-weight: bold;
    line-height: 22px;
    min-width: ${props => props.width || '110px'};
    opacity: 1;
    padding: ${props => props.padding || '6px 18px'};
    text-transform: inherit;
    width: ${props => props.width};
  }

  .MuiTab-wrapper {
    align-items: ${({ align }) => {
      switch (align) {
        case 'left':
          return 'flex-start'
        case 'right':
          return 'flex-end'
        case 'center':
        default:
          return 'center'
      }
    }};
  }

  &:hover {
    background-color: ${props => props.theme.palette.custom.gray[50.1]};
    text-decoration: none;
  }

  &.Mui-selected {
    color: ${props => props.theme.palette.blue[50]};
  }
`

export const LoadingWrapper = styled('div')`
  align-items: center;
  display: flex;
  height: 48px;
  width: 120px;
`
